import { addDays } from "date-fns";
import React, { Fragment, memo, useContext, useEffect, useState } from "react";
// Provider
import { AppContext } from "../../components/AppProvider";

// Utils

// UI
import { Container } from "../Layout";

import { userHabit } from "../../modules/utils/UserHabit";

// Network
import { PostApi951 } from "../../modules/network/padoPost";

import { Base64 } from "js-base64";
import { NativeAction } from "../../modules/utils/HandleWs";
import useTitle from "../../modules/hooks/useTitle";

export default props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const [list, setList] = useState(null);

  useTitle("마이페이지_공지사항");

  const handleRequest951 = () => {
    PostApi951(cfg)
      .then(res => {
        console.log(res);
        if (res.resultCode === "000") {
          setList(res.resultList);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    handleRequest951();
  }, []);

  // useEffect(() => {
  //   $(".board-toggle-list > div > a").click(function () {
  //     $(this).toggleClass("on");
  //     $(this).next(".view-box").slideToggle("fast");
  //   });
  // }, []);

  useEffect(() => {
    userHabit(phonecfg, "NT100");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <Container
        Title={"이벤트/공지사항"}
        dark={"dark"}
        isMain={false}
        goToUrl={"/mp"}
        // goToUrl={userinfo == "" || userinfo.userToken == "" ? "/" : "/mp"}
      >
        <div className="contents">
          <div className="sub-contents">
            <div className="board-toggle-list">
              {list !== null &&
                list.map((m, i) => (
                  <Notice
                    key={m.noticeID}
                    title={m.title}
                    date={m.noticeDate}
                    msg={m.content}
                    idx={i}
                  />
                ))}
            </div>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};

const Notice = memo(({ title, date, msg, idx }) => {
  const writeDay = new Date(date.substring(0, 10));
  const today = new Date();
  // new icono 보여주는 조건 : 7일간 new icon 표시
  const newDay = addDays(today, -6);

  const newIcon =
    writeDay >= newDay ? ` <span className='newicon'></span>` : "";
  const [toggle, setToggle] = useState(false);

  return (
    <div>
      <a
        onClick={e => {
          // $(e.target).toggleClass("on");
          setToggle(!toggle);
          $("#viewBox" + idx).slideToggle("fast");
        }}
        className={toggle ? "on" : ""}>
        <div className="subject">
          <div
            dangerouslySetInnerHTML={{ __html: Base64.decode(title) + newIcon }}
          />
        </div>
        <p>{getDateFormat(date)}</p>
      </a>
      <div className="view-box" id={"viewBox" + idx}>
        <div dangerouslySetInnerHTML={{ __html: Base64.decode(msg) }} />
      </div>
    </div>
  );
});

const week = new Array("(일)", "(월)", "(화)", "(수)", "(목)", "(금)", "(토)");
const getDateFormat = dateStr => {
  if (dateStr == null || dateStr.length !== 19) return dateStr;

  //   const day = new Date(dayjs(dateStr.substring(0, 10)).format("YYYY/MM/DD HH:mm:ss")).getDay();
  //   console.log(day);

  //   return dateStr.substring(0, 10) + week[day];
  return dateStr.substring(0, 10);
};
